import { booleanAttribute, ChangeDetectionStrategy, Component, input } from '@angular/core';

import { EvaluationMeterComponent } from './evaluation-meter.component';

@Component({
  selector: 'rt-summary-evaluation-meter',
  imports: [EvaluationMeterComponent],
  template: `<rt-evaluation-meter
    [rating]="rating()"
    [isHidden]="isHidden()"
    isClickable="false"
  />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SummaryEvaluationMeterComponent {
  public rating = input.required<number | null>();

  public isHidden = input<boolean, boolean | string>(false, { transform: booleanAttribute });
}
